"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
var _validate = require("@/utils/validate");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: "CreatGrade",
  props: {
    show: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    formType: {
      type: String,
      default: function _default() {
        return 'add';
      }
    },
    user: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      formValidate: {},
      status: 1,
      loading: false,
      userList: [],
      activeName: 'first'
    };
  },
  computed: {
    rules: function rules() {
      return {
        uid: [{
          required: true,
          message: this.$t('qsrzh'),
          trigger: 'blur'
        }],
        direction: [{
          required: true,
          message: this.$t('qxzzjlx'),
          trigger: 'change'
        }],
        money: [{
          required: true,
          message: this.$t('qsrzengJianye'),
          trigger: 'blur'
        }],
        remark: [{
          required: true,
          message: this.$t('qsreditReason'),
          trigger: 'blur'
        }]
      };
    }
  },
  watch: {
    user: {
      deep: true,
      // 深度监听，监听对象中的属性变化
      handler: function handler(newVal) {
        if (Object.keys(newVal).length > 0) {
          this.formValidate = JSON.parse(JSON.stringify(newVal));
          this.formValidate.type = this.formValidate.type == 1 ? this.$t('htcz') : this.$t('qtcz');
          this.status = newVal.status;
        } else {
          this.formValidate = {};
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {},
  methods: {
    setUrl: function setUrl(url) {
      return (0, _index.preFixxUrl)(url);
    },
    submitForm: (0, _validate.Debounce)(function (formName) {
      var _this = this;
      this.$refs.user.validate(function (valid) {
        if (valid) {
          var _this$formValidate = _this.formValidate,
            id = _this$formValidate.id,
            explain = _this$formValidate.explain,
            status = _this$formValidate.status;
          if (_this.formValidate.status == 2 && _this.formValidate.explain == '') {
            _this.$message.warning(_this.$t('qsrtgly'));
            return false;
          }
          _this.loading = true;
          (0, _user.reviewRechargeInfo)({
            id: id,
            explain: explain,
            status: status
          }).then(function (res) {
            _this.$message.success(_this.$t('ysh'));
            _this.$emit("cancel");
          }).finally(function () {
            _this.loading = false;
          });
        } else {
          return false;
        }
      });
    }),
    handleClose: function handleClose() {
      this.$emit("cancel");
    },
    resetForm: function resetForm(formName) {
      this[formName] = {};
      this.$emit("cancel");
    }
  }
};
exports.default = _default2;